import { createModel } from "@rematch/core";
import { RootModel } from "../rootModel";

export const summationRows = createModel<RootModel>()({
  state: {
    rows: [
      { name: "Recuento", value: "0" },
      { name: "Total facturas seleccionadas", value: "0" },
      { name: "Total", value: "0" },
    ],
  } as any,
  reducers: {
    setSummationRows(state, payload) {
      state.rows = payload;
    },
    clearSummationRows() {
      return { rows: [] };
    },
  },
});
